import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        realname:'',
        newNotice:0,
        islogin:false,
        userInfo:{},
        accountInfo:{},
        companyInfo:{},
        authorize:[],
        isceo:false,
        noticeInfo:{
            newnum:0,
            num:0,
            data:[]
        },
        hasPhone:false,
        public_info:{}
    },
    mutations:{
        //es6语法，等同edit:funcion(){...}
        getUserInfo(state,userInfo){
            state.userInfo = userInfo
        },
        ChangeLoginStatus(state,status){
            state.islogin=status
        },
        ChangeCompanyInfo(state,companyInfo){
            state.companyInfo=companyInfo
        },


        ChangeAccountInfo(state,accountInfo){
            state.accountInfo=accountInfo
        },

        SetNewCoins(state,newCoins){
            state.accountInfo.coins=newCoins
        },

        ChangeAuthorize(state,auth){
            state.authorize=auth

            if(auth.indexOf('ceo')!=-1){
                state.isceo=true
            }
        },

        SetNoticeInfo(state,info){
            state.noticeInfo=info
        },

        SubtractOneNotice(state){
            if(state.newnum>0){
                state.noticeInfo.newnum=state.noticeInfo.newnum-1
            }

        },
        SubtractAllNotice(state){
            state.noticeInfo.newnum=0
        },
        SetPhone(state,ishave){
            state.hasPhone=ishave
        },

        SetPublicInfo(state,info){
            state.public_info=info
        },

        


    }
})

export default store